import React from "react";
import "./Gifts.css";
import {
    getCurrency,
    getDatas,
    getProducts,
    getUtms,
    hidePage,
    makeLogo,
    setTable,
    showPage,
    updateCartNumber
} from "../extras/Actions";
import FondoCopos from "../Copitos/Copitos";

export default class Gifts extends React.Component{

    componentDidMount() {
        getCurrency()
        setTable()
        getUtms();
        hidePage()
        updateCartNumber()
        getProducts()

        if (window.location.href.includes("gifts") && localStorage.getItem("donors") !== null){
            makeLogo()
        }else{
            getDatas()
        }
        setTimeout(showPage,3000)
    }

    render() {
        return (
            <div className="gifts" id={"gifts"}>
                <div className="gift-title">
                    <button>
                        Elige tu regalo ahora
                    </button>
                </div>
                <div className="categories">

                </div>
                <div className="gifts-container">

                </div>
                <FondoCopos copitos={200}/>
            </div>
        );
    }
}